import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SharedservicesService } from '../../../../services/sharedservices.service';
import { HttpClient } from '@angular/common/http';
import { FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import {IPopup} from "ng2-semantic-ui";
import { HttpHeaders } from '@angular/common/http';
// import TinyDatePicker from 'tiny-date-picker';
declare var $: any;
@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {
  password: any;
  agentName: any;
  agentDateofBirth: any;
  npassword: any;
  ncpassword: any;
  select: any;
  email: any;
  mail: any;
  phone: any;
  zip: any;
  isChecked: boolean;
  stateInfo: any[] = [];
  countryInfo: any[] = [];
  cityInfo: any[] = [];
  serviceProvider: any[] = [];
  countryName: any;
  stateName: any;
  cityName: any;
  constructor(private router: Router, private ref: SharedservicesService, private http: HttpClient) {
    this.isChecked = true;
    this.serviceProvider.push({
      name: 'Airtel'
    })
  }
  
  ngOnInit() {
    this.getCountries();
  }
 
  checkValue(event: any) {
     console.log(event);
     console.log(this.isChecked);
  }
  checkphone(e) {
    this.phone = e;
    var strlength = this.phone.toString();
    if (strlength.length == 10) {
      var mailerr = <HTMLElement>document.getElementById('phonevalid');
      mailerr.style.display = 'block';
      var mailer = <HTMLElement>document.getElementById('phoneerr');
      mailer.style.display = 'none';
      // var mail = <HTMLElement>document.getElementById('phoneHelp');
      // mail.style.display = 'none';
      var btn = <HTMLInputElement>document.getElementById('button');
      btn.disabled = false;
    }
    else {
      var mailerr = <HTMLElement>document.getElementById('phonevalid');
      mailerr.style.display = 'none';
      var mailer = <HTMLElement>document.getElementById('phoneerr');
      mailer.style.display = 'block';
      // var mail = <HTMLElement>document.getElementById('phoneHelp');
      // mail.style.display = 'none';
    }
  }
  checkm(e) {
    this.email = e;
    var pattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*\.\w{2,3}/;
    if (e.match(pattern)) {
      var mailerr = <HTMLElement>document.getElementById('mailvalid');
      mailerr.style.display = 'block';
      var mailer = <HTMLElement>document.getElementById('mailerr');
      mailer.style.display = 'none';
      // var mail = <HTMLElement>document.getElementById('emailHelp');
      // mail.style.display = 'none';
      var btn = <HTMLInputElement>document.getElementById('button');
      btn.disabled = false;
    }
    else {
      var mailerr = <HTMLElement>document.getElementById('mailvalid');
      mailerr.style.display = 'none';
      var mailer = <HTMLElement>document.getElementById('mailerr');
      mailer.style.display = 'block';
      // var mail = <HTMLElement>document.getElementById('emailHelp');
      // mail.style.display = 'none';
    }
  }

  checkpw(e) {
    this.npassword = e;
    var pattern = /^.{6,}$/;
    if (e.match(pattern)) {
      var mailerr = <HTMLElement>document.getElementById('pwvalid');
      mailerr.style.display = 'block';
      var mailer = <HTMLElement>document.getElementById('pwerr');
      mailer.style.display = 'none';
      var btn = <HTMLInputElement>document.getElementById('button');
      btn.disabled = false;
    }
    else {
      var mailerr = <HTMLElement>document.getElementById('pwvalid');
      mailerr.style.display = 'none';
      var mailer = <HTMLElement>document.getElementById('pwerr');
      mailer.style.display = 'block';
    }
  }
  checkAgentName(e) {
    this.agentName = e;
    if(this.agentName!="") {
      var validName = <HTMLElement>document.getElementById('agentNameValid');
      validName.style.display = 'block';
      var invalidName = <HTMLElement>document.getElementById('agentNameErr');
      invalidName.style.display = 'none';
    } else {
      var validName = <HTMLElement>document.getElementById('agentNameValid');
      validName.style.display = 'none';
      var invalidName = <HTMLElement>document.getElementById('agentNameErr');
      invalidName.style.display = 'block';
    }
  }
  checkcpw(e) {
    this.ncpassword = e;
    if (this.npassword == this.ncpassword) {
      var mailerr = <HTMLElement>document.getElementById('cpwvalid');
      mailerr.style.display = 'block';
      var mailer = <HTMLElement>document.getElementById('cpwerr');
      mailer.style.display = 'none';
    }
    else {
      var mailerr = <HTMLElement>document.getElementById('cpwvalid');
      mailerr.style.display = 'none';
      var mailer = <HTMLElement>document.getElementById('cpwerr');
      mailer.style.display = 'block';
    }
  }
  onChange(e) {
    this.select = e;
  }

  //Country city and state
  
  getCountries(){
    this.ref.allCountries().
    subscribe(
      data2 => {
        this.countryInfo=data2.Countries;
        //console.log('Data:', this.countryInfo);
      },
      err => console.log(err),
      () => console.log('complete')
    )
  }
  dateCheckEvent(agentDob) {
    var dateformat = /^\d{4}-\d{2}-\d{2}$/;
    var today = new Date();
    var birthDate = new Date(agentDob);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    if(agentDob.match(dateformat)) {
      var myDate = new Date(agentDob);
      var today = new Date();
      var agentBirthDate = myDate.getDate();
      var agentBirthMonth = myDate.getMonth();
      var todayDate = today.getDate();
      var todayMonth = today.getMonth();
      
      if ( myDate > today ) { 
        var validName = <HTMLElement>document.getElementById('dateValid');
        validName.style.display = 'none';
        var invalidName = <HTMLElement>document.getElementById('dateInvalid');
        invalidName.style.display = 'block';
        var invalidName = <HTMLElement>document.getElementById('dateValidHappyBirthday');
        invalidName.style.display = 'none';
        var invalidName = <HTMLElement>document.getElementById('date18plus');
        invalidName.style.display = 'none';
      } else if(todayDate == agentBirthDate && todayMonth==agentBirthMonth && age>=18){ //Happy birthday check
        var invalidName = <HTMLElement>document.getElementById('dateValidHappyBirthday');
        invalidName.style.display = 'block';
        var validName = <HTMLElement>document.getElementById('dateValid');
        validName.style.display = 'none';
        var invalidName = <HTMLElement>document.getElementById('dateInvalid');
        invalidName.style.display = 'none';
        var invalidName = <HTMLElement>document.getElementById('date18plus');
        invalidName.style.display = 'none';
        this.agentDateofBirth = agentDob;
      } else if(myDate < today) { //validate age 18+ years
        if(age>=18) {
          var invalidName = <HTMLElement>document.getElementById('dateValidHappyBirthday');
          invalidName.style.display = 'none';
          var validName = <HTMLElement>document.getElementById('dateValid');
          validName.style.display = 'block';
          var invalidName = <HTMLElement>document.getElementById('dateInvalid');
          invalidName.style.display = 'none';
          var invalidName = <HTMLElement>document.getElementById('date18plus');
          invalidName.style.display = 'none';
          this.agentDateofBirth = agentDob;
        } else if(age<18) {
          var invalidName = <HTMLElement>document.getElementById('dateValidHappyBirthday');
          invalidName.style.display = 'none';
          var validName = <HTMLElement>document.getElementById('dateValid');
          validName.style.display = 'none';
          var invalidName = <HTMLElement>document.getElementById('dateInvalid');
          invalidName.style.display = 'none';
          var invalidName = <HTMLElement>document.getElementById('date18plus');
          invalidName.style.display = 'block';
        }
      }
    }
  }

  onChangeCountry(countryValue) {
    this.countryName = countryValue.CountryName;
    var countryLocation = this.countryInfo.findIndex(data => data.CountryName == countryValue.CountryName);
    this.stateInfo=this.countryInfo[countryLocation].States;
    this.stateName = undefined;
    if(countryValue!="") {
      var validName = <HTMLElement>document.getElementById('countryValid');
      validName.style.display = 'block';
      var invalidName = <HTMLElement>document.getElementById('countryInvalid');
      invalidName.style.display = 'none';
      var validStateName = <HTMLElement>document.getElementById('stateValid');
      validStateName.style.display = 'none';
      var invalidStateName = <HTMLElement>document.getElementById('stateInvalid');
      invalidStateName.style.display = 'block';
      this.cityInfo=this.stateInfo[0].Cities;
    } else {
      var validName = <HTMLElement>document.getElementById('countryValid');
      validName.style.display = 'none';
      var invalidName = <HTMLElement>document.getElementById('countryInvalid');
      invalidName.style.display = 'block';
    }
  }

  onChangeState(stateValue) {
    this.stateName = stateValue.StateName;
    if(stateValue!="") {
      var validName = <HTMLElement>document.getElementById('stateValid');
      validName.style.display = 'block';
      var invalidName = <HTMLElement>document.getElementById('stateInvalid');
      invalidName.style.display = 'none';
      this.cityInfo=this.stateInfo[0].Cities;
    } else {
      var validName = <HTMLElement>document.getElementById('stateValid');
      validName.style.display = 'none';
      var invalidName = <HTMLElement>document.getElementById('stateInvalid');
      invalidName.style.display = 'block';
    }

    // var stateLocation = this.stateInfo.findIndex(data => data.StateName == stateValue.StateName);
    // console.log(stateLocation);
    this.cityInfo=stateValue.Cities;

    // this.cityInfo=this.stateInfo[stateValue].Cities;
    //console.log(this.cityInfo);
  }
  onChangeCity(cityValue) {
    this.cityName = cityValue;
  }
  //Country city and state

  loginfun() {
    this.router.navigate(['/'], { queryParams: {} });
  }
  result: any;
  apiRoot: string = this.ref.GetPostURL();
  
  register() {
    var agentCustomerCheck  = this.isChecked;
    var passwordpattern = /^.{6,}$/;
    var emailpattern = /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/;
    var email;
    var pwd;
    var confpwd;
    var phone;
    var strlength;
    var agentName = this.agentName;
    var agentDOB = this.agentDateofBirth;
    var countryName = this.countryName;
    var stateName = this.stateName;
    if (agentCustomerCheck === true) { //Customer check
      email = (<HTMLInputElement>document.getElementById("exampleInputEmail1"));
      pwd = (<HTMLInputElement>document.getElementById("exampleInputPassword1"));
      confpwd = (<HTMLInputElement>document.getElementById("confpwd"));
      phone = (<HTMLInputElement>document.getElementById("number"));
      strlength = phone.value.toString();
      if (this.npassword == "" && this.email == "" && this.password == "" && this.phone == "") {
        var mailerr = <HTMLElement>document.getElementById('filled');
        mailerr.style.display = 'block';
        var btn = <HTMLInputElement>document.getElementById('button');
        btn.disabled = true;
      } else if(email.value.match(emailpattern) && pwd.value == confpwd.value && pwd.value.match(passwordpattern) && strlength.length == 10) {
        //Please commet line 135 and uncomment 136, if you want to the registration using agent
        //Use the same UI for the registration once done check into the database
        // const posturluser: string = this.apiRoot + 'agent/registration'; //agent registration
        
        var currentdate = new Date();
        var datetime = "Last Sync: " + currentdate.getDate() + "/"+(currentdate.getMonth()+1) 
        + "/" + currentdate.getFullYear() + " @ " 
        + currentdate.getHours() + ":" 
        + currentdate.getMinutes() + ":" + currentdate.getSeconds();
        var CustomerInfo = {
          'phone': phone.value,
          'email': email.value,
          'password': pwd.value,
          'registration_date': datetime,
          'token': '',
          'usertype': 'usercustomer',
        }; 
        var customerData = JSON.parse(JSON.stringify(CustomerInfo));
        this.ref.CustomerRegistration(customerData).subscribe((res) => {
          if (res) {
            const resultD = JSON.parse(JSON.stringify(res));
            this.result = resultD;
            CustomerInfo.token = this.result.token;
            this.ref.storeDatabwComp(CustomerInfo);
            this.router.navigate(['/'], { queryParams: {} });
          }
        },
        error => {
            console.log("Error", error.error.message);
            var value = (<HTMLInputElement>document.getElementById("EmailPassErr"));
            var allFiled = (<HTMLInputElement>document.getElementById("filled"));
            allFiled.style.display = 'none';
            value.style.display = 'block';
          }
        );
        // this.http.post(posturluser, customerData).subscribe(
        //   data => {
        //     this.result = data;
        //     CustomerInfo.token = this.result.token;
        //     this.ref.storeDatabwComp(CustomerInfo);
        //     // var value = (<HTMLInputElement>document.getElementById("EmailPassErr"));
        //     // value.style.display = 'none';
        //     this.router.navigate(['/'], { queryParams: {} });
        //   },
        //   error => {
        //     console.log("Error", error.error.message);
        //     var value = (<HTMLInputElement>document.getElementById("EmailPassErr"));
        //     var allFiled = (<HTMLInputElement>document.getElementById("filled"));
        //     allFiled.style.display = 'none';
        //     value.style.display = 'block';
        //   }
        // );
      }
      else {
        var btn = <HTMLInputElement>document.getElementById('button');
        btn.disabled = false;
        var mailerr = <HTMLElement>document.getElementById('filled');
        mailerr.style.display = 'block';
      }
    } else if(agentCustomerCheck==false) { //For Agent Registration
      email = (<HTMLInputElement>document.getElementById("exampleInputEmail1"));
      pwd = (<HTMLInputElement>document.getElementById("exampleInputPassword1"));
      confpwd = (<HTMLInputElement>document.getElementById("confpwd"));
      phone = (<HTMLInputElement>document.getElementById("number"));
      strlength = phone.value.toString();

      var agentName = this.agentName;
      var agentDOB = this.agentDateofBirth;
      var countryName = this.countryName;
      var stateName = this.stateName;
      if (agentName ==undefined &&  agentDOB==undefined &&  countryName==undefined && stateName==undefined && this.npassword == "" && this.email == "" && this.password == "" && this.phone == "") {
        var mailerr = <HTMLElement>document.getElementById('filled');
        mailerr.style.display = 'block';
        var btn = <HTMLInputElement>document.getElementById('button');
        btn.disabled = true;
      } else if(agentName != undefined &&  agentDOB!=undefined &&  countryName!=undefined && stateName!=undefined && email.value.match(emailpattern) && pwd.value == confpwd.value && pwd.value.match(passwordpattern) && strlength.length == 10) {
        //Please commet line 135 and uncomment 136, if you want to the registration using agent
        //Use the same UI for the registration once done check into the database
        var currentdate = new Date();
        var datetime = "Last Sync: " + currentdate.getDate() + "/"+(currentdate.getMonth()+1) 
        + "/" + currentdate.getFullYear() + " @ " 
        + currentdate.getHours() + ":" 
        + currentdate.getMinutes() + ":" + currentdate.getSeconds();
        var AgentInfo = {
          'name': agentName,
          'agentDob': agentDOB,
          'countryName': countryName,
          'cityName': this.cityName,
          'phone': phone.value,
          'email': email.value,
          'password': pwd.value,
          'registration_date': datetime,
          'token': '',
          'usertype': 'usercustomer',
        };

        const agentData = JSON.parse(JSON.stringify(AgentInfo));

        this.ref.AgentRegistration(agentData).subscribe((res) => {
          if (res) {
            const resultD = JSON.parse(JSON.stringify(res));
            this.result = resultD;
            AgentInfo.token = this.result.token;
            this.router.navigate(['/'], { queryParams: {} });
          }
        },
        error => {
            console.log("Error", error.error.message);
            var value = (<HTMLInputElement>document.getElementById("EmailPassErr"));
            var allFiled = (<HTMLInputElement>document.getElementById("filled"));
            allFiled.style.display = 'none';
            value.style.display = 'block';
          }
        );

        // this.http.post(posturluser, agentData).subscribe(
        //   data => {
        //     this.result = data;
        //     AgentInfo.token = this.result.token;
        //     this.router.navigate(['/'], { queryParams: {} });
        //   },
        //   error => {
        //     console.log("Error", error.error.message);
        //     var value = (<HTMLInputElement>document.getElementById("EmailPassErr"));
        //     var allFiled = (<HTMLInputElement>document.getElementById("filled"));
        //     allFiled.style.display = 'none';
        //     value.style.display = 'block';
        //   }
        // );
      }
      else {
        var btn = <HTMLInputElement>document.getElementById('button');
        btn.disabled = false;
        var mailerr = <HTMLElement>document.getElementById('filled');
        mailerr.style.display = 'block';
      }
    }
  }
}
